
/**
 * 获取当前打开webview的app类型
 */
export function getWebviewUa(): "line" | "facebook" | "wechat" | "weibo" | "other" {
    const ua = navigator.userAgent.toLowerCase();

    if (ua.includes("line")) {
        return "line";
    } else if (ua.includes("fbav")) {
        return "facebook";
    } else if (ua.includes("micromessenger")) {
        return "wechat";
    } else if (ua.includes("weibo")) {
        return "weibo";
    } else {
        return "other";
    }
}
